import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { IM360Parser } from '../../IM360Parser'

export function parseHowManySeeHowSeeThem({
  title,
  statement,
  studentResponse,
}: {
  title?: string
  statement?: string
  studentResponse?: string
}) {
  if (!studentResponse || !statement || !isHMSHSTQuestion(statement)) return
  const answers = activityAnswers(studentResponse)
  return [
    ...sampleResponse(studentResponse, answers),
    activityQuestions({ statement, answers, title }),
  ]
}

function sampleResponse(studentResponse: string, answers: string[]) {
  // if we have an answers array we want to split them up and include in each
  // question part, if not we want to add the sample response as a note node
  if (answers.length) return []
  return [
    IM360Parser.getInstance().createNoteNode({
      title: 'Sample Responses',
      value: studentResponse,
      studentFacing: false,
    }),
  ]
}

function isHMSHSTQuestion(statement?: string) {
  if (!statement) return false
  const asHtml = parseHtmlString(statement)
  const questionContent = asHtml.body.textContent?.trim()
  const TEST_STRING = 'How many do you see?How do you see them?'
  return questionContent === TEST_STRING
}

function activityQuestions({
  statement,
  answers,
  title,
}: {
  title?: string
  statement: string
  answers: string[]
}) {
  const asHtml = parseHtmlString(statement)
  const htmlParts = Array.from(asHtml.body.getElementsByTagName('figure'))
  const questions = htmlParts.map((q, index) => {
    q.remove()
    return IM360Parser.getInstance().createShortAnswer({
      title,
      description: q.outerHTML,
      teacherNote: answers[index],
    })
  })
  return IM360Parser.getInstance().createMultiPartQuestion(
    asHtml.body.innerHTML,
    questions,
  )
}

function activityAnswers(studentResponse: string) {
  const asHtml = parseHtmlString(studentResponse)
  const answersList = asHtml.getElementsByTagName('ul').item(0)
  return Array.from(answersList?.getElementsByTagName('li') ?? []).map(
    (ans) => ans.innerHTML,
  )
}
